export default __webpack_public_path__ + "static/research_partners-eaa21e4a752304f54879d8574f503937.svg";